module.exports = {
  locales: ['de', 'en', 'fr'],
  defaultLocale: 'de',
  defaultNS: 'common',
  logBuild: false,
  pages: {
    '*': ['common'],
  },
};
